// Cosmetic only: Shopify still serves and protects the /password route.
(() => {
  if (window.self !== window.top || window.Shopify?.designMode) return;
  const url = new URL(window.location.href);
  if (!/\/password\/?$/.test(url.pathname) || url.searchParams.has('preview_theme_id')) return;

  url.pathname = url.pathname.replace(/\/password\/?$/, '/');
  try {
    // Keep campaign parameters, anchors and the existing history entry intact.
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  } catch {
    // If unavailable, leave the protected page and its original URL unchanged.
  }
})();
